import React from "react";

export default function Checkbox({isChecked, isCheckedNot, handleOnChangeCheck, handleOnChangeNot}) {

    return (
        <div className="entidadesWrapper">
            <div className="entidadesText">
                <p>
                    <b>¿Pertenecés a algunas de estas entidades?</b>
                    <div className={"clearXmin"}></div>
                    <span>
                        AFIP, Banco Nación, ANSES, EPE, Aguas Santafesinas, PAMI, Vialidad Nacional, CONICET o Bancos Oficiales Nacionales.
                    </span>
                </p>
            </div>
            <div className="topping">
                <input
                    type="checkbox"
                    id="checkbox"
                    name="checkbox"
                    value="Si"
                    checked={isChecked}
                    onChange={handleOnChangeCheck}
                />
                <p>Si</p>
                <div className={"clearInput"}></div>
                <input
                    type="checkbox"
                    id="checkbox"
                    name="checkbox"
                    value="No"
                    checked={isCheckedNot}
                    onChange={handleOnChangeNot}
                />
                <p>No</p>
            </div>
        </div>
    );
}

